import React, {useState, useEffect} from 'react'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import clsx from 'clsx'
import {checkIsActive, KTIcon} from '../../../helpers'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasArrow?: boolean
  hasBullet?: boolean
}

const MenuItem: React.FC<Props> = ({
  to,
  title,
  icon,
  fontIcon,
  hasArrow = false,
  hasBullet = false,
}) => {
  const {pathname} = useLocation()
  const [hoveredItem, setHoveredItem] = useState(false) // Specify the type here
  const handleHover = (isHovered: boolean) => {
    setHoveredItem(isHovered )
  }
  return (
    <>
      <Link
        className={clsx(
          hoveredItem
            ? 'bg-info text-center  p-3 border-top-0  border-start-0 border-end-0 bg-opacity-10 border border-primary border-4 rounded'
            : 'menu-item bg-white rounded p-3 text-center menu-link',
          {
            'bg-info bg-white  border-start-0 text-center border-end-0 bg-opacity-10 border border-primary border-4 rounded active':
              checkIsActive(pathname, to),
          }
        )}
        to={to}
        onMouseEnter={() => handleHover(true)}
        onMouseLeave={() => handleHover(false)}
      >
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}

        {icon && (
          <span className='menu-icon'>
            <KTIcon iconName={icon} className='fs-2' />
          </span>
        )}

        {fontIcon && (
          <span className='menu-icon'>
            <i className={clsx('bi fs-3', fontIcon)}></i>
          </span>
        )}

        <span className='menu-title'>{title}</span>

        {hasArrow && <span className='menu-arrow'></span>}
      </Link>
    </>
  )
}

export {MenuItem}
